module.exports = __webpack_public_path__ + "img/logo-_2.fe5ebe15.svg";